/* WOLF BROS - Smart Search ENGINE (Arabic + typo tolerant matching, ranking) */
(function (root) {
  'use strict';

  /* ------------------------------------------------------------------ */
  /*  1. TEXT NORMALISATION + DICTIONARIES                                */
  /* ------------------------------------------------------------------ */

  function baseNorm(s) {
    s = String(s || '').toLowerCase();
    try { s = s.normalize('NFKD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    s = s
      .replace(/[ً-ٰٟـ]/g, '')      // tashkeel + tatweel
      .replace(/[أإآٱ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي')
      .replace(/ؤ/g, 'و').replace(/ئ/g, 'ي').replace(/ڤ/g, 'ف').replace(/[گ]/g, 'ج').replace(/پ/g, 'ب')
      .replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 1632); })
      .replace(/['’`´]/g, '')
      .replace(/\bt[\s\-]?shirts?\b/g, 'tshirt')
      .replace(/\b(\d)\s*\/\s*(\d)\b/g, '$1-$2')
      .replace(/[^a-z0-9؀-ۿ\-]+/g, ' ')
      .replace(/(^|\s)-+|-+(\s|$)/g, ' ')
      .replace(/\s+/g, ' ').trim();
    return s;
  }

  function stem(t) {
    if (/[؀-ۿ]/.test(t)) return t;
    if (t.length > 4 && /ies$/.test(t)) return t.slice(0, -3) + 'y';
    if (t.length > 3 && /s$/.test(t) && !/ss$/.test(t)) return t.slice(0, -1);
    return t;
  }

  // Arabic / slang phrases -> english (keys are normalised with baseNorm at init)
  var PHRASES = {
    'تي شيرت': 'tshirt', 'تى شيرت': 'tshirt', 'سويت شيرت': 'sweatshirt', 'سويت بانتس': 'sweatpants',
    'سويت بانت': 'sweatpants', 'بول اند بير': 'pull bear', 'بول آند بير': 'pull bear', 'بول بير': 'pull bear',
    'جاك اند جونز': 'jack jones', 'جاك جونز': 'jack jones', 'نورث فيس': 'north face', 'ذا نورث فيس': 'north face',
    'يو اس بولو': 'us polo', 'يو اس': 'us polo', 'اوف وايت': 'off white', 'كوارتر زيب': 'quarter zipper',
    'هاف زيب': 'half zip', 'تيرتل نيك': 'turtleneck', 'هاي كول': 'turtleneck', 'تومي هيلفيجر': 'tommy hilfiger',
    'كالفن كلاين': 'calvin klein', 'سي كي': 'calvin klein', 'هوجو بوس': 'boss', 'كارل لاجرفيلد': 'karl lagerfeld',
    'ارماني اكستشينج': 'armani exchange', 'اونلي اند سونز': 'only sons', 'اوفر سايز': 'oversized', 'شورت بحر': 'swim',
    'zip up': 'zipup', 'zip-up': 'zipup', 'half zip': 'half zip', 'off-white': 'off white', 'crew neck': 'crew',
    'اقل من': '__lt', 'تحت': '__lt', 'under': '__lt', 'below': '__lt', 'less than': '__lt',
    'اكتر من': '__gt', 'اكثر من': '__gt', 'فوق': '__gt', 'over': '__gt', 'above': '__gt', 'more than': '__gt'
  };

  var WORDS = {
    // garments
    'جاكيت': 'jacket', 'جاكت': 'jacket', 'جكت': 'jacket', 'جاكيته': 'jacket', 'جواكت': 'jacket', 'جاكيتات': 'jacket', 'جاكتات': 'jacket',
    'هودي': 'hoodie', 'هوديز': 'hoodie', 'هود': 'hoodie', 'هوودي': 'hoodie', 'هوديات': 'hoodie',
    'سويتشيرت': 'sweatshirt', 'سويشيرت': 'sweatshirt', 'سويت': 'sweat', 'سويتشرت': 'sweatshirt',
    'بلوفر': 'pullover', 'بولوفر': 'pullover', 'بلوفرات': 'pullover', 'بلوفار': 'pullover', 'سويتر': 'sweater', 'تريكو': 'pullover',
    'ترينج': 'sweatpants', 'ترنج': 'sweatpants', 'جوجر': 'jogger', 'جوغر': 'jogger', 'سويتبانتس': 'sweatpants',
    'بنطلون': 'pants', 'بنطلونات': 'pants', 'بنطال': 'pants',
    'تيشيرت': 'tshirt', 'تيشرت': 'tshirt', 'تشيرت': 'tshirt', 'تيشيرتات': 'tshirt', 'تي': 'tshirt',
    'قميص': 'shirt', 'قمصان': 'shirt', 'شيرت': 'shirt', 'بولو': 'polo', 'جينز': 'jeans', 'جينزات': 'jeans',
    'شورت': 'shorts', 'شورتات': 'shorts', 'طقم': 'set', 'اطقم': 'set', 'سيت': 'set', 'سيتات': 'set',
    'تيرتلنيك': 'turtleneck', 'هايكول': 'turtleneck', 'مايوه': 'swim', 'مايوهات': 'swim',
    'لينين': 'linen', 'لينن': 'linen', 'كتان': 'linen', 'فانله': 'undershirt', 'فانلات': 'undershirt', 'فانلة': 'undershirt',
    'كوارتر': 'quarter', 'زيب': 'zip', 'سوسته': 'zip', 'زيبر': 'zipper', 'كابشون': 'hoodie',
    'رجالي': 'men', 'رجالى': 'men', 'حريمي': 'women', 'نسائي': 'women', 'اوفرسايز': 'oversized', 'شتوي': 'winter', 'شتوى': 'winter',
    // colours
    'اسود': 'black', 'سودا': 'black', 'ابيض': 'white', 'بيضا': 'white', 'كحلي': 'navy', 'نيفي': 'navy', 'رمادي': 'grey', 'رصاصي': 'grey',
    'جراي': 'grey', 'جري': 'grey', 'بيج': 'beige', 'بني': 'brown', 'بنى': 'brown', 'اخضر': 'green', 'خضرا': 'green', 'زيتي': 'olive',
    'زيتوني': 'olive', 'اوليف': 'olive', 'احمر': 'red', 'حمرا': 'red', 'نبيتي': 'burgundy', 'عنابي': 'burgundy', 'بيرجندي': 'burgundy',
    'برجندي': 'burgundy', 'ازرق': 'blue', 'زرقا': 'blue', 'لبني': 'blue', 'اصفر': 'yellow', 'صفرا': 'yellow', 'كريمي': 'cream', 'كريم': 'cream',
    'كاميل': 'camel', 'جملي': 'camel', 'كامل': 'camel', 'موف': 'purple', 'بنفسجي': 'purple', 'برتقالي': 'orange', 'اورنج': 'orange', 'وردي': 'pink',
    'بينك': 'pink', 'تركواز': 'turquoise', 'تركوازي': 'turquoise', 'مينت': 'mint', 'فحمي': 'charcoal', 'كورال': 'coral', 'سيمون': 'coral',
    'اوتميل': 'oatmeal', 'توب': 'taupe', 'سيدج': 'sage', 'دهبي': 'gold', 'فضي': 'silver',
    // brands
    'زارا': 'zara', 'بيرشكا': 'bershka', 'برشكا': 'bershka', 'بيرشكة': 'bershka', 'تومي': 'tommy', 'جاب': 'gap', 'بوس': 'boss',
    'بوما': 'puma', 'مانجو': 'mango', 'مانغو': 'mango', 'ليفايز': 'levis', 'ليفيز': 'levis', 'ليفاي': 'levis', 'كالفن': 'calvin',
    'جيس': 'guess', 'اديداس': 'adidas', 'تمبرلاند': 'timberland', 'تيمبرلاند': 'timberland', 'هوليستر': 'hollister',
    'ارماني': 'armani', 'جانت': 'gant', 'كارل': 'karl', 'ايسنشيال': 'essential', 'اسينشيال': 'essential', 'اسنشيال': 'essential',
    'ايسينشال': 'essential', 'ايسنشال': 'essential', 'اسينشال': 'essential', 'لي': 'lee', 'نورث': 'north',
    // english slang / variants
    'hoody': 'hoodie', 'hoodi': 'hoodie', 'hood': 'hoodie', 'tee': 'tshirt', 'jumper': 'pullover', 'gray': 'grey', 'trouser': 'pants',
    'pant': 'pants', 'jogger': 'sweatpants', 'joggers': 'sweatpants', 'trackpant': 'sweatpants', 'track': 'sweatpants',
    'sweatpant': 'sweatpants', 'zipup': 'zip', 'quarterzip': 'quarter zipper', 'xxl': '2xl', 'xxxl': '3xl', 'swimming': 'swim'
  };

  // a query word can satisfy any of these product words
  var GROUPS = {
    pullover: ['pullover', 'sweater', 'jumper'],
    sweater: ['sweater', 'pullover', 'sweatshirt'],
    pants: ['pants', 'trousers', 'trouser', 'sweatpants', 'jeans', 'jean', 'linen', 'chino', 'cargo'],
    sweatpants: ['sweatpants', 'sweatpant', 'jogger', 'trackpant'],
    sweat: ['sweatshirt', 'sweatpants', 'sweatpant'],
    jeans: ['jeans', 'jean', 'denim'],
    zip: ['zip', 'zipper', 'zipup'],
    zipper: ['zipper', 'zip'],
    hoodie: ['hoodie', 'hoody'],
    swim: ['swim', 'swiming', 'swimming', 'swimsuit', 'swimwear'],
    tshirt: ['tshirt', 't-shirt', 'tee'],
    grey: ['grey', 'gray', 'charcoal'],
    turtleneck: ['turtleneck', 'turtle', 'mock'],
    blue: ['blue', 'navy', 'denim'],
    winter: ['winter', 'pullover', 'hoodie', 'jacket', 'sweatshirt', 'sweater', 'turtleneck']
  };

  var STOP = { 'and': 1, 'the': 1, 'of': 1, 'for': 1, 'in': 1, 'with': 1, 'a': 1, 'an': 1, 'original': 1, 'اند': 1, 'في': 1, 'من': 1, 'و': 1, 'لون': 1, 'اللون': 1, 'مقاس': 1, 'عايز': 1, 'عاوز': 1, 'جنيه': 1, 'ج': 1, 'le': 1, 'egp': 1 };

  var SIZE_ORDER = ['xxs', 'xs', 's', 'm', 'l', 'xl', '2xl', '3xl', '4xl', '5xl'];
  var SIZE_ALIASES = { 'xxl': '2xl', 'xxxl': '3xl', 'xxxxl': '4xl', 'سمول': 's', 'ميديم': 'm', 'لارج': 'l', 'اكس لارج': 'xl' };

  var COLOR_FAMILIES = {
    black: '#111', white: '#f5f5f5', grey: '#8d8d8d', navy: '#1d2b4f', blue: '#3a6fd8', olive: '#6b6b2f', green: '#2f7d46',
    beige: '#d9c7a7', cream: '#efe6d0', oatmeal: '#d8ccb4', taupe: '#8b7d6b', camel: '#c19a6b', brown: '#6b4528', burgundy: '#6d1a2b',
    red: '#c62828', orange: '#ef7d22', yellow: '#f2d23c', pink: '#ec8fb1', purple: '#7a4fa0', turquoise: '#2bb5b0', mint: '#9de0c3',
    coral: '#ff7f6b', sage: '#a3b18a', charcoal: '#3a3d42', khaki: '#b5a36a', silver: '#c0c0c0', gold: '#c9a53a'
  };

  var PHRASE_LIST = [];
  (function () {
    Object.keys(PHRASES).forEach(function (k) { PHRASE_LIST.push([baseNorm(k), PHRASES[k]]); });
    PHRASE_LIST.sort(function (a, b) { return b[0].length - a[0].length; });
    var w = {}; Object.keys(WORDS).forEach(function (k) { w[baseNorm(k)] = WORDS[k]; }); WORDS = w;
    var g = {}; Object.keys(GROUPS).forEach(function (k) { g[stem(k)] = GROUPS[k].map(function (x) { return stem(baseNorm(x).replace(/\s+/g, '')); }); }); GROUPS = g;
  })();

  function tokensOf(s) {
    return baseNorm(s).split(' ').filter(Boolean).map(stem);
  }

  /* ------------------------------------------------------------------ */
  /*  2. FUZZY HELPERS                                                    */
  /* ------------------------------------------------------------------ */

  function dist(a, b, max) {   // Damerau-Levenshtein (optimal string alignment) with early exit
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var prev2 = null, prev = new Array(lb + 1), cur;
    for (var j = 0; j <= lb; j++) prev[j] = j;
    for (var i = 1; i <= la; i++) {
      cur = new Array(lb + 1); cur[0] = i; var rowMin = cur[0];
      for (j = 1; j <= lb; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (prev2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v; if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[lb];
  }

  /* ------------------------------------------------------------------ */
  /*  3. INDEX                                                            */
  /* ------------------------------------------------------------------ */

  function titleCase(s) { return String(s || '').replace(/\w\S*/g, function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }); }

  function colorFamily(name) {
    var t = baseNorm(name).split(' ');
    for (var i = t.length - 1; i >= 0; i--) {
      var w = WORDS[t[i]] || t[i]; if (w === 'gray') w = 'grey';
      if (COLOR_FAMILIES[w]) return w;
      if (w === 'heather' || w === 'marl') continue;
    }
    if (/off ?white|ivory|ecru/.test(baseNorm(name))) return 'cream';
    return baseNorm(name) || null;
  }

  function sizeKey(v) { var s = baseNorm(v).replace(/\s+/g, ''); return SIZE_ALIASES[s] || s; }

  function imgUrl(src, w) {
    if (!src) return '';
    src = src.replace(/^http:/, 'https:');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 400);
  }

  function buildIndex(products) {
    var entries = [], vocab = {}, surface = {}, guard = {};
    Object.keys(WORDS).forEach(function (k) { tokensOf(WORDS[k]).forEach(function (t) { guard[t] = 1; }); });
    Object.keys(GROUPS).forEach(function (k) { guard[k] = 1; });
    products.forEach(function (p) {
      if (!p || !p.variants || !p.variants.length) return;
      var opts = p.options || [];
      var cIdx = -1, sIdx = -1;
      opts.forEach(function (o, i) {
        var n = baseNorm(o.name);
        if (cIdx < 0 && /^(colou?r|اللون|لون)$/.test(n)) cIdx = i;
        if (sIdx < 0 && /(size|مقاس)/.test(n)) sIdx = i;
      });
      var colors = cIdx >= 0 ? (opts[cIdx].values || []) : [null];
      var anyAvail = p.variants.some(function (v) { return v.available; });
      var split = cIdx >= 0 && colors.length > 1 && anyAvail;
      var created = Date.parse(p.created_at || p.published_at) || 0;
      var vendor = String(p.vendor || '').trim();
      var type = String(p.product_type || '').trim();
      var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');

      (split ? colors : [colors[0]]).forEach(function (color) {
        var vars = color === null || !split ? p.variants : p.variants.filter(function (v) { return v['option' + (cIdx + 1)] === color; });
        var avail = vars.filter(function (v) { return v.available; });
        if (split && !avail.length) return;           // same rule as collection colour cards
        var pick = avail[0] || vars[0];
        var img = '';
        for (var i = 0; i < vars.length && !img; i++) if (vars[i].featured_image) img = vars[i].featured_image.src;
        if (!img && p.images) {
          var ids = vars.map(function (v) { return v.id; });
          for (var k = 0; k < p.images.length && !img; k++) {
            var vi = p.images[k].variant_ids || [];
            if (vi.some(function (id) { return ids.indexOf(id) > -1; })) img = p.images[k].src;
          }
        }
        if (!img && p.images && p.images[0]) img = p.images[0].src;
        var prices = (avail.length ? avail : vars).map(function (v) { return parseFloat(v.price); });
        var price = Math.min.apply(null, prices);
        var cmp = 0;
        (avail.length ? avail : vars).forEach(function (v) { var c = parseFloat(v.compare_at_price || 0); if (c > cmp) cmp = c; });
        var sizes = [];
        if (sIdx >= 0) avail.forEach(function (v) { var s = sizeKey(v['option' + (sIdx + 1)]); if (s && sizes.indexOf(s) < 0) sizes.push(s); });
        var colorName = color && cIdx >= 0 ? color : null;
        var e = {
          id: p.id + (colorName ? ':' + colorName : ''),
          pid: p.id,
          title: p.title,
          color: colorName,
          family: colorName ? colorFamily(colorName) : null,
          vendor: titleCase(vendor),
          type: titleCase(type),
          url: '/products/' + p.handle + (split && pick ? '?variant=' + pick.id : ''),
          img: img,
          price: price,
          compare: cmp > price ? cmp : 0,
          sizes: sizes,
          available: avail.length > 0,
          created: created,
          colorCount: split ? colors.length : 1,
          f: {}
        };
        if (!e.family) {   // one-colour products: take the colour from the title ("Hoodie in Black")
          var tt = tokensOf(p.title);
          for (var z = tt.length - 1; z >= 0; z--) { var cw = WORDS[tt[z]] || tt[z]; if (cw === 'gray') cw = 'grey'; if (COLOR_FAMILIES[cw]) { e.family = cw; break; } }
        }
        var add = function (str, w) {
          baseNorm(str).split(' ').forEach(function (o) { var t0 = stem(o); if (o && !surface[t0]) surface[t0] = o; });
          tokensOf(str).forEach(function (t) {
            if (STOP[t] && t !== 'original') return;
            if (!e.f[t] || e.f[t] < w) e.f[t] = w;
            vocab[t] = (vocab[t] || 0) + 1;
          });
        };
        add(p.title, 3);
        add(colorName || '', 3.2);
        if (e.family) add(e.family, 2.6);
        add(vendor, 2.8);
        add(type, 3);
        tokensOf(type).forEach(function (t) { guard[t] = 1; });
        add(tags.join(' '), 1.2);
        add(p.handle.replace(/-/g, ' '), 0.6);
        entries.push(e);
      });
    });
    return { entries: entries, vocab: Object.keys(vocab), freq: vocab, surface: surface, guard: guard };
  }

  /* ------------------------------------------------------------------ */
  /*  4. QUERY PARSING + SEARCH                                           */
  /* ------------------------------------------------------------------ */

  function parseQuery(q, index) {
    var s = ' ' + baseNorm(q) + ' ';
    PHRASE_LIST.forEach(function (p) { s = s.split(' ' + p[0] + ' ').join(' ' + p[1] + ' '); });
    var raw = s.trim().split(' ').filter(Boolean);
    var out = { terms: [], sizes: [], min: null, max: null, corrections: {} };
    var hasSizes = {};
    index.entries.forEach(function (e) { e.sizes.forEach(function (z) { hasSizes[z] = 1; }); });
    for (var i = 0; i < raw.length; i++) {
      var t = raw[i];
      if (t === '__lt' || t === '__gt') {
        var n = parseFloat(raw[i + 1]);
        if (!isNaN(n)) { if (t === '__lt') out.max = n; else out.min = n; i++; }
        continue;
      }
      var ar = WORDS[t] || (t.indexOf('ال') === 0 && WORDS[t.slice(2)]) || null;
      if (!ar && /ات$/.test(t)) ar = WORDS[t.slice(0, -2)] || WORDS[t.slice(0, -2) + 'ه'] || null;
      var mapped = ar || t;
      mapped.split(' ').forEach(function (m) {
        var sk = SIZE_ALIASES[m] || m;
        var looksSize = /^(\d?x{0,3}[sl]|m|\d?xl)$/.test(sk) && SIZE_ORDER.indexOf(sk) > -1;
        if (looksSize && hasSizes[sk] && (sk.length > 1 || raw.length > 1)) { out.sizes.push(sk); return; }
        if (STOP[m]) return;
        m = stem(m);
        if (WORDS[m] && WORDS[m].indexOf(' ') < 0 && stem(WORDS[m]) !== m) m = stem(WORDS[m]);
        if (STOP[m]) return;
        var alts = GROUPS[m] ? GROUPS[m].map(stem) : [m];
        if (alts.indexOf(m) < 0) alts.unshift(m);
        out.terms.push({ q: m, alts: alts, dict: !!ar, arabic: /[؀-ۿ]/.test(m) });
      });
    }
    return out;
  }

  // quality of query term against every vocab word (computed once per query)
  function termMatches(term, vocab, freq, guard) {
    var res = {}, typo = {}, syn = {}, guess = null, guessQ = 0;
    term.alts.forEach(function (a, ai) {
      var penalty = ai === 0 ? 1 : 0.92;
      var maxD = (ai > 0 || term.dict) ? 0 : (a.length >= 7 ? 2 : (a.length >= 4 ? 1 : 0));
      for (var i = 0; i < vocab.length; i++) {
        var w = vocab[i], qv = 0, isTypo = false;
        if (w === a) qv = 1;
        else if (a.length >= 2 && w.indexOf(a) === 0) qv = 0.9 - Math.min(0.15, (w.length - a.length) * 0.015);
        else if (maxD) {
          var d = dist(a, w, maxD);
          if (d <= maxD) { qv = d === 1 ? 0.7 : 0.55; isTypo = true; }
          else if (a.length >= 4 && w.length > a.length && dist(a, w.slice(0, a.length), 1) <= 1) { qv = 0.5; isTypo = true; }  // typo while typing
        }
        qv *= penalty;
        if (qv > (res[w] || 0)) {
          res[w] = qv; if (isTypo) typo[w] = 1; else delete typo[w];
          if (ai > 0) syn[w] = 1; else delete syn[w];
        }
      }
    });
    var exact = false;
    for (var w in res) {
      if (!typo[w]) { exact = true; continue; }
      var sc = res[w] + Math.min(0.2, (freq[w] || 0) / 200);
      if (sc > guessQ) { guessQ = sc; guess = w; }
    }
    // the word exists as typed: don't let typos turn it into a different garment / colour / brand (tshirt -> shirt)
    if (exact && guard) for (w in typo) if (guard[w]) { delete res[w]; delete typo[w]; }
    return { q: res, typo: typo, syn: syn, guess: exact ? null : guess };
  }

  function search(index, q, opts) {
    opts = opts || {};
    var pq = parseQuery(q, index);
    var tm = pq.terms.map(function (t) { return termMatches(t, index.vocab, index.freq, index.guard); });
    var results = [];
    index.entries.forEach(function (e) {
      if (pq.min !== null && e.price < pq.min) return;
      if (pq.max !== null && e.price > pq.max) return;
      if (pq.sizes.length && !pq.sizes.some(function (s) { return e.sizes.indexOf(s) > -1; })) return;
      var score = 0, matched = 0, strong = true, direct = true;
      for (var i = 0; i < tm.length; i++) {
        var best = 0, bestW = null, qm = tm[i].q;
        for (var w in e.f) {
          var qv = qm[w];
          if (qv) { var sc = qv * e.f[w]; if (sc > best) { best = sc; bestW = w; } }
        }
        if (best > 0) { matched++; score += best; if (tm[i].typo[bestW]) strong = false; if (tm[i].syn[bestW]) direct = false; }
      }
      if (tm.length && !matched) return;
      results.push({ e: e, score: score, matched: matched, all: matched === tm.length, strong: strong, tier: strong ? (direct ? 0 : 1) : 2 });
    });
    var strict = results.filter(function (r) { return r.all; });
    var loose = false;
    if (!strict.length && tm.length > 1) {
      var need = Math.ceil(tm.length / 2);
      strict = results.filter(function (r) { return r.matched >= need; });
      loose = true;
    }
    var sort = opts.sort || 'newest';
    strict.sort(function (a, b) {
      if (a.e.available !== b.e.available) return a.e.available ? -1 : 1;
      if (sort === 'price-asc') return a.e.price - b.e.price;
      if (sort === 'price-desc') return b.e.price - a.e.price;
      if (sort === 'relevance') return (b.score - a.score) || (b.e.created - a.e.created);
      // newest: exact/prefix matches first, then typo matches; each newest -> oldest
      if (a.tier !== b.tier) return a.tier - b.tier;
      if (loose && a.matched !== b.matched) return b.matched - a.matched;
      return (b.e.created - a.e.created) || (b.score - a.score);
    });
    var corrected = null;
    if (strict.length && tm.some(function (m) { return m.guess; })) {
      corrected = pq.terms.map(function (t, i) { var g = tm[i].guess; return g ? (index.surface[g] || g) : t.q; }).join(' ');
    }
    return { items: strict.map(function (r) { return r.e; }), parsed: pq, loose: loose, corrected: corrected };
  }

  var Engine = { version: 3, baseNorm: baseNorm, tokensOf: tokensOf, buildIndex: buildIndex, search: search, parseQuery: parseQuery, dist: dist, titleCase: titleCase, imgUrl: imgUrl, COLOR_FAMILIES: COLOR_FAMILIES, SIZE_ORDER: SIZE_ORDER };

  if (typeof module !== 'undefined' && module.exports) { module.exports = Engine; return; }
  root.WBSearchEngine = Engine;
})(typeof window !== 'undefined' ? window : globalThis);
